import React from 'react';
import PropTypes from 'prop-types';
import pageLoadingIndicator from '@mapbox/mr-ui/page-loading-indicator';
import {
  addRouteChangeStartListener,
  addRouteChangeEndListener
} from '@mapbox/batfish/modules/route-change-listeners';
import { AppContext } from '../context.js';

if (typeof window !== 'undefined') {
  import(
    /* webpackChunkName: "assembly-js" */ '@mapbox/mbx-assembly-docs/dist/assembly.js'
  );
}

addRouteChangeStartListener(() => {
  pageLoadingIndicator.start();
});
addRouteChangeEndListener(() => {
  pageLoadingIndicator.end();
});

class ApplicationWrapper extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      userAccessToken: undefined
    };
  }

  componentDidMount() {
    MapboxPageShell.afterUserCheck(() => {
      this.setState({
        userAccessToken: MapboxPageShell.getUserPublicAccessToken()
      });
    });
  }

  render() {
    const context = {
      userAccessToken: this.state.userAccessToken
    };

    return (
      <AppContext.Provider value={context}>
        {this.props.children}
      </AppContext.Provider>
    );
  }
}

ApplicationWrapper.propTypes = {
  children: PropTypes.node
};

export default ApplicationWrapper;
